module.exports = __webpack_public_path__ + "static/media/power.2375c4e8.svg";